"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MpOffer = void 0;
var react_1 = __importStar(require("react"));
var mp_context_1 = require("../context/mp-context");
var useMpState_1 = require("../hooks/useMpState");
var MpIframe_1 = require("../iframe/MpIframe");
var useResetStoreOnUnmount_1 = require("../hooks/useResetStoreOnUnmount");
var build_iframe_core_query_params_1 = require("../iframe/build-iframe-core-query-params");
var constants_1 = require("../constants");
var MpOffer = function (props) {
    var basketId = props.basketId, page = props.page;
    var _a = (0, mp_context_1.useMpContext)(), country = _a.country, pointOfSale = _a.pointOfSale, currency = _a.currency, language = _a.language, locale = _a.locale, mpStore = _a.mpStore, affiliateId = _a.affiliateId, platform = _a.platform, reportError = _a.reportError;
    var _b = (0, useMpState_1.useMpState)(), isLoading = _b.isLoading, multiProducts = _b.multiProducts;
    (0, react_1.useEffect)(function () {
        mpStore
            .getOffers({
            basketId: basketId,
            currency: currency,
            ipCountry: country,
            pointOfSale: pointOfSale,
            language: locale,
            affiliateId: affiliateId,
            platform: platform,
            page: page,
        })
            .catch(function (error) {
            error = error || new Error(constants_1.UNKNOWN_ERROR);
            error.message = "".concat(constants_1.MULTI_PRODUCT_ERROR_PREFIX, " fetching offers: ").concat(error.message);
            if (reportError) {
                reportError(error, constants_1.MULTI_PRODUCT_ACTION_NAME);
            }
        });
    }, [
        basketId,
        country,
        pointOfSale,
        currency,
        language,
        locale,
        mpStore,
        affiliateId,
        platform,
        page,
        reportError,
    ]);
    (0, useResetStoreOnUnmount_1.useResetStoreOnUnMount)();
    if (isLoading || !multiProducts.length) {
        return null;
    }
    var step = 'select';
    var siteType = (platform === null || platform === void 0 ? void 0 : platform.toUpperCase()) || '';
    var queryParams = (0, build_iframe_core_query_params_1.buildIframeCoreQueryParams)({
        country: country,
        currency: currency,
        locale: locale,
        step: step,
        siteType: siteType,
    });
    var mfeItems = multiProducts
        .map(function (mpProduct) {
        var productType = mpProduct.productType;
        switch (productType) {
            // INSURANCE MFE
            case 'INSURANCE': {
                var productMFEUrl = mpProduct.productMFEUrl, productId = mpProduct.productId;
                // Extra params specific to the productType
                queryParams.append('quoteId', productId);
                var iframeUrl = "".concat(productMFEUrl, "?").concat(queryParams.toString());
                return (react_1.default.createElement(MpIframe_1.MpIframe, { key: "INSURANCE-".concat(productId), iframeTitle: "Insurance MFE", url: iframeUrl, anchorStep: step, productType: productType, productId: productId }));
            }
            default: {
                return null;
            }
        }
    })
        .filter(function (item) { return item !== null; });
    return react_1.default.createElement(react_1.default.Fragment, null, mfeItems);
};
exports.MpOffer = MpOffer;
